var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "liste",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4412 7.5H8.33823C7.44485 7.5 7.44485 8.1 7.44485 9C7.44485 9.9 7.44485 10.5 8.33823 10.5H21.4412C22.3346 10.5 22.3346 9.9 22.3346 9C22.3346 8.1 22.3346 7.5 21.4412 7.5ZM24.4191 15H8.33823C7.44485 15 7.44485 15.6 7.44485 16.5C7.44485 17.4 7.44485 18 8.33823 18H24.4191C25.3125 18 25.3125 17.4 25.3125 16.5C25.3125 15.6 25.3125 15 24.4191 15ZM8.33823 3H24.4191C25.3125 3 25.3125 2.4 25.3125 1.5C25.3125 0.6 25.3125 0 24.4191 0H8.33823C7.44485 0 7.44485 0.6 7.44485 1.5C7.44485 2.4 7.44485 3 8.33823 3ZM3.57353 7.5H0.893382C0 7.5 0 8.1 0 9C0 9.9 0 10.5 0.893382 10.5H3.57353C4.46691 10.5 4.46691 9.9 4.46691 9C4.46691 8.1 4.46691 7.5 3.57353 7.5ZM3.57353 15H0.893382C0 15 0 15.6 0 16.5C0 17.4 0 18 0.893382 18H3.57353C4.46691 18 4.46691 17.4 4.46691 16.5C4.46691 15.6 4.46691 15 3.57353 15ZM3.57353 0H0.893382C0 0 0 0.6 0 1.5C0 2.4 0 3 0.893382 3H3.57353C4.46691 3 4.46691 2.4 4.46691 1.5C4.46691 0.6 4.46691 0 3.57353 0Z",
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.bd0d691a.svg";
export { ForwardRef as ReactComponent };